import React, { useState } from "react";
import "../Contact/Contact.css"; // Ensure this path points to your CSS file

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Form validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid Email Format";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be 10 digits (no dashes)";
    }
    if (!formData.message.trim()) newErrors.message = "Message is required";
    return newErrors;
  };

  // Handle form input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      setSuccessMessage("");
      setErrorMessage("");
    } else {
      setErrors({});
      setLoading(true);

      try {
        // Send form data to backend API (replace with your backend URL)
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/contact`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const result = await response.json();

        if (response.ok) {
          setSuccessMessage("Your message has been sent successfully!");
          setFormData({ name: "", email: "", phone: "", message: "" });
        } else {
          setErrorMessage(result.message || "Failed to send message. Please try again later.");
        }
      } catch (error) {
        setErrorMessage("Failed to send message. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="contact-page py-5">
      <div className="container">
        <h1 className="text-center mb-5 page-title">Get in Touch</h1>
        <div className="row">
          {/* Contact Information Section */}
          <div className="col-lg-6">
            <div className="contact-info p-4 shadow">
              <h2 className="info-title mb-4">Contact Information</h2>
              <ul className="list-unstyled">
                <li className="mb-3">
                  <i className="fas fa-phone me-3"></i>
                  <a className="contactLinks" href="tel:9990168777">(+91) 9990168777</a>
                </li>
                <li className="mb-3">
                  <i className="fas fa-envelope me-3"></i>
                  <a className="contactLinks" href="mailto:wow@printingy.com">wow@printingy.com</a>
                </li>
                <li className="mb-3">
                  <i className="fas fa-map-marker-alt me-3"></i>
                  <span>301-C, 3rd Floor, Supermart 2, DLF Phase IV, Gurgaon</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="col-lg-6">
            <div className="form-wrapper p-4 shadow">
              <h2 className="form-title mb-4">Send Us a Message</h2>
              <form onSubmit={handleSubmit}>
                {successMessage && <div className="alert alert-success mb-3">{successMessage}</div>}
                {errorMessage && <div className="alert alert-danger mb-3">{errorMessage}</div>}

                {/* Name Input */}
                <div className="mb-3">
                  <input
                    type="text"
                    className={`form-control ${errors.name ? "is-invalid" : ""}`}
                    id="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  {errors.name && <div className="text-danger">{errors.name}</div>}
                </div>

                {/* Email Input */}
                <div className="mb-3">
                  <input
                    type="email"
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    id="email"
                    placeholder="youremail@example.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && <div className="text-danger">{errors.email}</div>}
                </div>

                {/* Phone Input */}
                <div className="mb-3">
                  <input
                    type="tel"
                    className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                    id="phone"
                    placeholder="1234567890"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                  {errors.phone && <div className="text-danger">{errors.phone}</div>}
                </div>

                {/* Message Input */}
                <div className="mb-3">
                  <textarea
                    className={`form-control ${errors.message ? "is-invalid" : ""}`}
                    id="message"
                    rows="5"
                    placeholder="Write your message here..."
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                  {errors.message && <div className="text-danger">{errors.message}</div>}
                </div>

                {/* Submit Button */}
                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
